<style lang="scss" scoped>
.pagination {
    padding: 10px;
}
.spacer {
    margin: 0 5px 0 5px;
}
</style>
<template lang="pug">
div
    table.table.sync__table
        tbody
            tr(v-for="row in paginated")
                td {{ row.name }}
                td 
                    span(v-if="!isMultipleChanges(row)") {{ row.message | capitalize }}
                    template(v-else)
                        span(v-for="change in getChanges(row)")
                            strong {{ change.key }}: 
                            span 
                                span {{ change.from }} 
                                i.spacer(class="el-icon-right")
                                span {{ change.to }}
                            br

    el-pagination.pagination(background="", layout="prev, pager, next", :current-page.sync="page", :page-size="per_page", :total="rows.length")
</template>
<script>
import _ from "lodash";

export default {
    data() {
        return {
            page: 1,
            per_page: 1000,
        };
    },

    props: {
        rows: Array,
    },

    computed: {
        paginated() {
            return _.chunk(this.rows, this.per_page)[this.page - 1];
        },
    },
    
    methods: {
        getChanges(row) {
            return JSON.parse(row.message)
        },

        isMultipleChanges(row) {
            try {
                JSON.parse(row.message);
                return true;
            } catch (e) {
                return false;
            }
        }
    },
};
</script>
